<template>
  <v-toolbar
    color="primary"
    fixed
    dark
    app
    >
    <v-toolbar-title class="ml-0 pl-3">
      <v-toolbar-side-icon @click.stop="handleDrawerToggle"></v-toolbar-side-icon>
    </v-toolbar-title>
        <v-btn @click="searchMember" icon>
          <v-icon>search</v-icon>
        </v-btn>
        <span>{{'members._search_members_'|translate}}</span>
        <v-divider
      class="mx-3"
      inset
      vertical
    ></v-divider>
        <v-btn @click="postPrayer" icon>
          <v-icon>announcement</v-icon>
        </v-btn>
        <span>{{'prayers._prayers_title_'|translate}}</span>
        <v-divider
      class="mx-3"
      inset
      vertical
    ></v-divider>
       
        <span></span>
      <v-spacer></v-spacer>
      <v-btn @click="addNewMember">
        {{'members._new_members_'|translate}}
      </v-btn> 
       <language-dropdown/>     
      <v-btn icon @click="handleFullScreen()">
        <v-icon>fullscreen</v-icon>
      </v-btn>
      <v-menu offset-y origin="center center" class="elelvation-1" :nudge-bottom="14" transition="scale-transition">
        <v-btn icon flat slot="activator">
        <v-badge color="red" overlap>
          <span slot="badge">3</span>
          <v-icon medium>notifications</v-icon>
        </v-badge>
        </v-btn>
        <notification-list></notification-list>
      </v-menu>
      <v-menu offset-y origin="center center" :nudge-bottom="10" transition="scale-transition">
        <v-btn icon large flat slot="activator">
          <v-avatar size="40px">
            <img :src="this.imageUrl" :alt="firstName"/>
          </v-avatar>
        </v-btn>
        <v-list class="pa-0">
          <v-list-tile v-for="(item,index) in items" @click="item.click" ripple="ripple" :disabled="item.disabled" :target="item.target" rel="noopener" :key="index">
            <v-list-tile-action v-if="item.icon">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }} </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu>
  </v-toolbar>
</template>
<script>
/* eslint-disable */
import { db } from '@/api/firebaseInit';
import firebase from 'firebase';
import NotificationList from '@/components/widgets/list/NotificationList';
import Util from '@/theme/util';
import LanguageDropdown from "./dropdowns/LanguageDropdown";
export default {
  name: 'app-toolbar',
  components: {
    NotificationList,
    LanguageDropdown
  },
  data: () => ({
    firstName: '',
    lastName: '',
    // imageUrl: '',
    isLoggedIn: false,
    isClerk: true,
    accessLevel: 'Clerck',
    member: {
    accessCode: '',
    member_id: '',
    createdById: '',
    createdDate: '',
    createdBy: '',
    imageUrl: '',
    consent: true,
    jobSkills: 'Professions',
    noReferralReason: 'Pas de références',
    noDonationReason: 'Pas de donations',
    noDimeReason: 'Pas de dîmes',
    volunteerTime: {
      amount: 0,
      frequency: 'Par mois',
    },
    donation: {
      amount: 0,
      frequency: 'Par mois',
    },
    jobSearch: {
          amount: 1,
          frequency: "mois"
        },
        jobDisponibility: {
          amount: 1,
          frequency: "Par mois"
        },
        timeOnCurrentJob: {
          amount: 6,
          frequency: "mois"
        },
        dime: {
          nombre: 0,
          frequency: "Par jour",
        },
        offrande: {
          nombre: 0,
          frequency: "Par semaine",
        }
    },
    items: [
      {
        icon: 'account_circle',
        href: 'Profile',
        title: 'Profile',
        click: (e) => {
            console.log(e);
            window.getApp.$emit('APP_PROFILE_REQUESTED');
         
        }
      },
      {
        icon: 'settings',
        href: '#',
        title: 'Settings',
        click: (e) => {
          console.log(e);
        }
      },
      {
        icon: 'fullscreen_exit',
        href: '#',
        title: 'Logout',
        click: (e) => {
          window.getApp.$emit('APP_LOGOUT');
        }
      }
    ],
  }),
  created () {
      if(firebase.auth().currentUser) {
        this.member.createdById = firebase.auth().currentUser.uid
        this.member.createdBy = firebase.auth().currentUser.displayName
        if(!this.member.createdBy) {
          this.member.createdBy = firebase.auth().currentUser.email
        }
      }
  },
  computed: {
    toolbarColor () {
      return this.$vuetify.options.extra.mainNav;
    },
      imageUrl () {
        let user = this.$store.getters.signinUser;
        let imageUrl = user.imageUrl
        return imageUrl
    }
  },
  methods: {
    fetchData(currentUser) {
         db
      .collection("Employees").doc(currentUser)
        .get()
        .then((doc) => {
            this.firstName = doc.data().firstName,
            this.lastName = doc.data().lastName,
            this.accessLevel = doc.data().accessLevel,
            this.imageUrl = doc.data().imageUrl,
            this.isLoggedIn = true
            if (this.accessLevel === "Admin") {
              this.isClerk = true
            } 
      })
  },
  addNewMember () {
    var newMemberRef = db.collection('Census').doc();
    var refAccess = newMemberRef.id
    this.member.member_id = refAccess
    this.member.accessCode = refAccess.substring(0, 5)
    newMemberRef.set({
      accessCode: this.member.accessCode,
      imageUrl: '/static/avatar/avatar.png',
      lowerAccessCode: this.member.accessCode.toLowerCase(),
      createdDate: new Date(),
      createdBy: this.member.createdBy,
      createdById: this.member.createdById,
      volunteerTime: this.member.volunteerTime,
      jobSearch: this.member.jobSearch,
      donation: this.member.donation,
      consent: this.member.consent,
      jobDisponibility: this.member.jobDisponibility,
      timeOnCurrentJob: this.member.timeOnCurrentJob,
      isWorking: 'Non',
      isWorkReady: 'Non',
      offrande: this.member.offrande,
      noReferralReason: this.member.noReferralReason,
      noDimeReason: this.member.noDimeReason,
      noDonationReason: this.member.noDonationReason,
      jobSkills: this.member.jobSkills,
      dime: this.member.dime
    })
    .then (() => {
      this.fetchCurrentMember(refAccess)
    })
  }, 
     fetchCurrentMember (payload) {
     
      db.collection('Census').doc(payload)
      .get()
      .then((doc) => {
        const form = {
             id: doc.id,
             imageUrl: doc.data().imageUrl,
             firstName: doc.data().firstName,
             lastName: doc.data().lastName,
             posteName: doc.data().posteName,
             accessCode: doc.data().accessCode,
             role: doc.data().role,
             phone: doc.data().phone,
             email: doc.data().email,
             dateOfBirth: doc.data().dateOfBirth,
             address: doc.data().address,
             gender: doc.data().gender,
             consent: doc.data().consent,
             city: doc.data().city,
             postalCode: doc.data().postalCode,
             isWithChildren: doc.data().isWithChildren,
             hasSmartPhone: doc.data().hasSmartPhone,
             noPhoneReason: doc.data().noPhoneReason,
             isBuyPhoneReady: doc.data().isBuyPhoneReady,
             maritalStatus: doc.data().maritalStatus,
             noVolunteerReason: doc.data().noVolunteerReason,
             isVolunteer: doc.data().isVolunteer,
             hasChildren: doc.data().hasChildren,
             volunteerFrequency: doc.data().volunteerFrequency,
             niveauScolaire: doc.data().niveauScolaire,
             churchName: doc.data().churchName,
             churchAttendance: doc.data().churchAttendance,
             memberSince: doc.data().memberSince,
             sermonTimeSpent: doc.data().sermonTimeSpent,
             noDimeReason: doc.data().noDimeReason,
             isreferralReady: doc.data().isreferralReady,
             noReferralReason: doc.data().noReferralReason,
             isVolunteerReady: doc.data().isVolunteerReady,
             noVolunteerReason: doc.data().noVolunteerReason,
             volunteerTime: doc.data().volunteerTime,
             noDonationReason: doc.data().noDonationReason,
             donation: doc.data().donation,
             isDimeContribution: doc.data().isDimeContribution,
             isDonationReady: doc.data().isDonationReady,
             // dimeAmount: doc.data().dimeAmount,
             dime: doc.data().dime,
             dimeType: doc.data().dimeType,
             isOffrandeContribution: doc.data().isOffrandeContribution,
             // offrandeAmount: doc.data().offrandeAmount,
             offrandeType: doc.data().offrandeType,
             offrande: doc.data().offrande,
             isGraceContribution: doc.data().isGraceContribution,
             // graceDonationAmount: doc.data().graceDonationAmount,
             graceContributionType: doc.data().graceContributionType,
             isWorking: doc.data().isWorking,
             createdDate: doc.data().createdDate,
             isWorkReady: doc.data().isWorkReady,
             notAvailableReason: doc.data().notAvailableReason,
             isEducationReady: doc.data().isEducationReady,
             isHouseOwner: doc.data().isHouseOwner,
             houseOwnerSince: doc.data().houseOwnerSince,
             isRenting: doc.data().isRenting,
             jobSkills: doc.data().jobSkills,
             jobSearch: doc.data().jobSearch,
             jobType: doc.data().jobType,
             availableTime: doc.data().availableTime,
             jobDisponibility: doc.data().jobDisponibility,
             timeOnCurrentJob: doc.data().timeOnCurrentJob,
             jobPosition: doc.data().jobPosition,
             numberOfJobs: doc.data().numberOfJobs,
             jobRepartition: doc.data().jobRepartition,
             jobWeeklyHours: doc.data().jobWeeklyHours,
             jobTravelDistance: doc.data().jobTravelDistance,
             jobTravelMode: doc.data().jobTravelMode,            
             jobTravelCost: doc.data().jobTravelCost,
             jobTravelTime: doc.data().jobTravelTime,
             jobMonthlyPay: doc.data().jobMonthlyPay
        }  

         if (
          doc.data().isBuyPhoneReady === null ||
          doc.data().isBuyPhoneReady === undefined
         ) {
           form.isBuyPhoneReady = "Non";
         }
         if (
          doc.data().isVolunteerReady === null ||
          doc.data().isVolunteerReady === undefined
         ) {
           form.isVolunteerReady = "Non";
         }
         if (
          doc.data().volunteerTime === null ||
          doc.data().volunteerTime === undefined
         ) {
           form.volunteerTime = {
            nombre: 0,
            frequency: 'Par jour'
           }
         }
          if (
          doc.data().houseOwnerSince === null ||
          doc.data().houseOwnerSince === undefined
         ) {
           form.houseOwnerSince = {
            nombre: 0,
            frequency: 'Par jour'
           }
          }
          if (
          doc.data().education === null ||
          doc.data().education === undefined
          ) {
          form.education = {
            nombre: 0,
            frequency: 'Par jour'
            }
          }
           if (
          doc.data().timeOnCurrentJob === null ||
          doc.data().timeOnCurrentJob === undefined
          ) {
          form.timeOnCurrentJob = {
            nombre: 0,
            frequency: 'Mois'
            }
          }
          if (
          doc.data().numberOfKids === null ||
          doc.data().noPhoneReason === undefined
          ) {
            form.numberOfKids = 0;
          }
          if (
            doc.data().noReferralReason === null ||
          doc.data().noReferralReason === undefined
          ) {
            form.noReferralReason = 'Pas de raison';
          }
          //  if (
          //   doc.data().noDonationReason === null ||
          //   doc.data().noDonationReason === undefined
          //  ) {
          //    form.noDonationReason = 'Pas de raison';
          //  }
          form.consent = true;
          this.$store.commit('currentMember', form);
        })
      this.$router.push('/form/newmember');
  },
  searchMember () {
    this.$router.push('/widgets/search')
  },
  postPrayer () {
    this.$router.push('/prayers')
  },
   openChat () {
    this.$store.dispatch('fetchConvos').then(() => {

      this.$store.dispatch('fetchMessages').then(() => {
         this.$router.push({name: 'ChatMessaging', params: {uuid: this.member.createdById}});
      })
    })
  }, 
    handleDrawerToggle () {
      window.getApp.$emit('APP_DRAWER_TOGGLED');
    },
    handleFullScreen () {
      Util.toggleFullScreen();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AppToolbar.vue